var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    {
      staticClass: "clvr-floating-card",
      class: {
        "clvr-floating-card--top": _setup.props.top,
        "clvr-floating-card--bottom": _setup.props.bottom,
      },
      attrs: { "no-gutters": "" },
    },
    [
      _c(
        "v-col",
        { attrs: { cols: "auto" } },
        [_c("kh-card", { staticClass: "pa-3" }, [_vm._t("default")], 2)],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }